module.exports = __webpack_public_path__ + "img/武桐桐.2274fa11.jpg";